<template>
    <v-row no-gutters>
        <v-col cols="7"
            :style="'border-radius:5px 0 0 0;height:' + (height ? height : '100') + 'px;background-color:' + beltColor">
            <div style="height:45%"></div>
            <div :style="'height:10%;background-color:' + horizontalLine"></div>
            <div style="height:45%"></div>
        </v-col>
        <v-col :style="'background-color:' + coverColor">
        </v-col>
        <v-col :style="'background-color:' + stripe4Color">
        </v-col>
        <v-col :style="'background-color:' + coverColor4">
        </v-col>
        <v-col :style="'background-color:' + stripe3Color">
        </v-col>
        <v-col :style="'background-color:' + coverColor3">
        </v-col>
        <v-col :style="'background-color:' + stripe2Color">
        </v-col>
        <v-col :style="'background-color:' + coverColor2">
        </v-col>
        <v-col :style="'background-color:' + stripe1Color">
        </v-col>
        <v-col :style="'border-radius:0 5px 0 0;background-color:' + coverColor1">
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: ["belt", "height", "notBjj"],
    data() {
        return {
            beltColor: null,
            horizontalLine: 'none',
            coverColor: 'black',
            coverColor4: 'black',
            coverColor3: 'black',
            coverColor2: 'black',
            coverColor1: 'black',
            stripe1Color: null,
            stripe2Color: null,
            stripe3Color: null,
            stripe4Color: null,
        }
    },
    methods: {
        getHorizontalLine() {
            const belt = this.belt;
            let horizontalLine = null;
            if (belt) {
                const split = belt.split('_');
                if (split.length == 2 && split[0] != 'red') {
                    horizontalLine = 'white';
                    if (split[1].indexOf('black') >= 0)
                        horizontalLine = 'black';
                }
            }
            return horizontalLine;
        }
    },
    created() {
        if (this.notBjj) {
            this.beltColor = 'white';
            this.stripe1Color = 'white';
            this.stripe2Color = 'white';
            this.stripe3Color = 'white';
            this.stripe4Color = 'white';
            this.coverColor = 'white';
            this.coverColor4 = 'white';
            this.coverColor3 = 'white';
            this.coverColor2 = 'white';
            this.coverColor1 = 'white';
            return;
        }
        this.horizontalLine = this.getHorizontalLine();
        let primaryColor = this.belt;
        let stripes = 0;
        const len = this.belt.length;
        const lastChar = this.belt.substring(len - 1, len);
        if (!isNaN(lastChar))
            stripes = new Number(lastChar).valueOf()
        if (primaryColor == "gray" || primaryColor.indexOf("gray") >= 0)
            primaryColor = "gray" + (stripes > 0 ? stripes : '');
        else if (primaryColor == "yellow" || primaryColor.indexOf("yellow") >= 0)
            primaryColor = "yellow" + (stripes > 0 ? stripes : '');
        else if (primaryColor == "orange" || primaryColor.indexOf("orange") >= 0)
            primaryColor = "orange" + (stripes > 0 ? stripes : '');
        else if (primaryColor == "green" || primaryColor.indexOf("green") >= 0)
            primaryColor = "green" + (stripes > 0 ? stripes : '');

        if (!primaryColor || primaryColor == 'bjjlover') {
            this.beltColor = 'white';
            this.stripe1Color = 'black';
            this.stripe2Color = 'black';
            this.stripe3Color = 'black';
            this.stripe4Color = 'black';
        } else if (primaryColor == 'coral') {
            this.beltColor = 'black';
            const redColor = this.themeColor('error');
            this.stripe1Color = redColor;
            this.stripe2Color = redColor;
            this.stripe3Color = redColor;
            this.stripe4Color = redColor;
        } else if (primaryColor == 'red_white') {
            this.beltColor = 'black';
            const redColor = this.themeColor('error');
            this.stripe1Color = redColor;
            this.stripe2Color = redColor;
            this.stripe3Color = redColor;
            this.stripe4Color = redColor;
            this.coverColor4 = 'white';
            this.coverColor3 = 'white';
            this.coverColor2 = 'white';
            this.coverColor1 = 'white';
        } else {
            let belt = primaryColor;
            if (belt.indexOf('white') == 0) {
                this.stripe1Color = 'black';
                this.stripe2Color = 'black';
                this.stripe3Color = 'black';
                this.stripe4Color = 'black';
            } else if (belt.indexOf('black') >= 0) {
                const redColor = this.themeColor('error');
                this.stripe1Color = redColor;
                this.stripe2Color = redColor;
                this.stripe3Color = redColor;
                this.stripe4Color = redColor;
            } else {
                this.stripe1Color = 'black';
                this.stripe2Color = 'black';
                this.stripe3Color = 'black';
                this.stripe4Color = 'black';
            }
            if (belt.indexOf('black') >= 0 && belt.indexOf('white') != 0) {
                const redColor = this.themeColor('error');
                this.coverColor = redColor;
                this.coverColor4 = redColor;
                this.coverColor3 = redColor;
                this.coverColor2 = redColor;
                this.coverColor1 = redColor;
            }
            if (isNaN(lastChar)) {
                //No stripes
                if (belt.indexOf('gray') >= 0) {
                    belt = 'gray';
                } else if (belt.indexOf('orange') >= 0) {
                    belt = 'orange';
                } else if (belt.indexOf('green') >= 0) {
                    belt = 'green';
                } else if (belt.indexOf('yellow') >= 0) {
                    belt = 'yellow';
                } else if (belt.indexOf('white') == 0) {
                    belt = 'white';
                }
                this.beltColor = this.themeColor(belt);
            } else {
                belt = belt.substring(0, len - 1);
                if (belt.indexOf('gray') >= 0) {
                    belt = 'gray';
                } else if (belt.indexOf('orange') >= 0) {
                    belt = 'orange';
                } else if (belt.indexOf('green') >= 0) {
                    belt = 'green';
                } else if (belt.indexOf('yellow') >= 0) {
                    belt = 'yellow';
                } else if (belt.indexOf('white') == 0) {
                    belt = 'white';
                }
                this.beltColor = this.themeColor(belt);
                if (stripes == 1) {
                    this.stripe1Color = 'white';
                } else if (stripes == 2) {
                    this.stripe1Color = 'white';
                    this.stripe2Color = 'white';
                } else if (stripes == 3) {
                    this.stripe1Color = 'white';
                    this.stripe2Color = 'white';
                    this.stripe3Color = 'white';
                } else if (stripes == 4) {
                    this.stripe1Color = 'white';
                    this.stripe2Color = 'white';
                    this.stripe3Color = 'white';
                    this.stripe4Color = 'white';
                }
            }
        }
    }
}
</script>

<style scoped></style>
